// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const ilinkstvColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: ilinkstvColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: ilinkstvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: ilinkstvColors.primaryGray,
    secondary: ilinkstvColors.secondaryGray,
    disabled: ilinkstvColors.grayText,
    link: ilinkstvColors.secondaryGray,
    hint: ilinkstvColors.white,
    highlight: ilinkstvColors.secondary,
    gray: ilinkstvColors.primaryGray,
    seeAll: ilinkstvColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: ilinkstvColors.primaryGray,
    gray: ilinkstvColors.secondaryGray,
  },
  filter: {
    primary: ilinkstvColors.primaryGray,
    secondary: ilinkstvColors.secondaryGray,
    disabled: ilinkstvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: ilinkstvColors.dark,
    color: ilinkstvColors.white,
    border: ilinkstvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: ilinkstvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: ilinkstvColors.dark,
        selected: ilinkstvColors.dark,
        progress: rgba(ilinkstvColors.primary, 0.3),
        past: rgba(ilinkstvColors.primary, 0.3),
        pastSelected: ilinkstvColors.dark,
        pastHover: ilinkstvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(ilinkstvColors.primary, 0.2),
      },
      text: {
        empty: ilinkstvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: ilinkstvColors.white,
    subTitle: ilinkstvColors.secondaryGray,
    bg: ilinkstvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
